import {notification} from 'antd';

export default {
    success: (message) => notification.success({message}),
    error: (message) => notification.error({message, duration: 0}),
};